export default __webpack_public_path__ + "static/Merriweather-Italic-131df1926d9476d8d6b4063808e2a3af.woff2";